import {ActivatedRoute, Router} from '@angular/router';
import {environment} from "../../../environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {BroadcasterService} from "../broadcaster.service";
import {GridDataResult} from "@progress/kendo-angular-grid";
const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class FormsService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    }
    async claimForm(formId): Promise<any> {
      try {
        const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/claimForm', {sid: localStorage.getItem('token')}));
        return res;
      } catch(e) {
        throw e;
      }
        // return new Observable<any>(observer => {
        //     this.http.post<any>(environment.apiUrl + 'de/claimForm',
        //         {sid: localStorage.getItem('token'), formId})
        //         .subscribe((res: any) => {
        //             observer.next(res);
        //         }, err => {
        //             observer.error(err);
        //         });
        // });
    }
  async downloadForm(id: any): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/getAbbyyPdf',
        {sid: localStorage.getItem('token'), afid: id}, {headers, responseType: 'blob' as 'json' }));
      return res;
    } catch(e) {
      throw e;
    }
  }
  async downloadAD(id) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      });
      try {
        const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/downloadADById',
          {sid: localStorage.getItem('token'), id}, {headers, responseType: 'blob' as 'json' }));
        return res;
      } catch(e) {
        throw e;
      }
        // return new Observable<any>(observer => {
        //     this.http.post<any>(environment.apiUrl + '/de/downloadADById',
        //         {sid: localStorage.getItem('token'), id}, {headers, responseType: 'blob' as 'json' })
        //         .subscribe((res: any) => {
        //             observer.next(res);
        //         }, err => {
        //             observer.error(err);
        //         });
        // });
    }
    async downloadPolst(id, orgId) {
      const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      });
      try {
        const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'downloadById',
          {sid: localStorage.getItem('token'), id, org_id: orgId}, {headers, responseType: 'blob' as 'json' }));
        return res;
      } catch(e) {
        throw e;
      }
        // return new Observable<any>(observer => {
        //     this.http.post<any>(environment.apiUrl + 'downloadById',
        //         {sid: localStorage.getItem('token'), id, org_id: orgId}, {headers, responseType: 'blob' as 'json' })
        //         .subscribe((res: any) => {
        //             observer.next(res);
        //         }, err => {
        //             observer.error(err);
        //         });
        // });
    }
    public toggleActiveForms(polsts, ads, isIehpPt): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'forms/toggleCurrentForm',
                {sid: localStorage.getItem('token'), pt_polsts: polsts, pt_advance_directives: ads, is_iehp_pt: isIehpPt})
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
  async loadNext(orgId, currentDateSubmitted, currentFormId): Promise<any>{
    try {
      const res = await firstValueFrom(this.http.post<any>(environment.apiUrl + 'de/loadNextForm', {sid: localStorage.getItem('token'),
        org_id: orgId, date_submitted: currentDateSubmitted, form_id: currentFormId}));
      return res;
    } catch(e) {
      throw e;
    }
  }
    // public loadNext(index): Observable<any> {
    //     return new Observable<any>(observer => {
    //         this.http.post<any>(environment.apiUrl + 'de/loadNextForm',
    //             {sid: localStorage.getItem('token'), index})
    //             .subscribe((res: any) => {
    //                 observer.next(res);
    //             }, err => {
    //                 observer.error(err);
    //             });
    //     });
    // }
}
